import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Profile.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Navbar from "../../Navbar";
import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Tabs from "react-bootstrap/Tabs";
import { TiTick } from "react-icons/ti";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { usePaymentInputs } from "react-payment-inputs";

axios.defaults.baseURL =
  "https://project-manager-backend-afgb.onrender.com/user/";

const Profile = () => {
  const [user, setUser] = useState({
    name: "",
    surname: "",
    email: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [modalVisible, setModalVisible] = useState(false);
  const [searchString, setSearchString] = useState("");

  const [currentPlan, setCurrentPlan] = useState("");
  const [upgradedPlan, setUpgradedPlan] = useState("");
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [showpayment, setShowpayment] = useState(false);
  const handleShowpaymentModal = () => setShowpayment(true);

  const handleClosepayment = () => setShowpayment(false);
  const [queryMessage, setQueryMessage] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("card");
  const [cardNumber, setCardNumber] = useState("");
  const [expiryDate, setExpiryDate] = useState("");

  const [upiId, setUpiId] = useState("");

  const [cvc, setCvc] = useState("");

  // Get payment input props from the hook
  const { meta, getCardNumberProps, getExpiryDateProps, getCVCProps } =
    usePaymentInputs();

  // Change handlers
  const handleChangeCardNumber = (e) => setCardNumber(e.target.value);
  const handleChangeExpiryDate = (e) => setExpiryDate(e.target.value);
  const handleChangeCVC = (e) => {
    console.log("=============>change", e);
    setCvc(e.target.value);
  };

  const handleShow = () => setShow(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    axios
      .get("/profile", { headers: { Authorization: `Bearer ${token}` } })
      .then((response) => {
        setUser({
          name: response.data.name,
          surname: response.data.surname,
          email: response.data.email,
          newPassword: "",
          confirmPassword: "",
        });
      })
      .catch((error) => console.error("Error fetching profile:", error));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUser((prevUser) => ({ ...prevUser, [name]: value }));
  };

  const handleUpdate = () => {
    if (user.newPassword && user.newPassword !== user.confirmPassword) {
      alert("New Password and Confirm Password must match!");
      return;
    }

    const token = localStorage.getItem("token");
    axios
      .put(
        "/profile",
        { name: user.name, surname: user.surname, password: user.newPassword },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then(() => {
        setModalVisible(true);
        setUser((prevUser) => ({
          ...prevUser,
          newPassword: "",
          confirmPassword: "",
        }));
      })
      .catch((error) => console.error("Error updating profile:", error));
  };
  const handleSubscription = async () => {
    const token = localStorage.getItem("token");

    try {
      const paymentDetails = {
        paymentMethod,
        cardNumber:
          paymentMethod === "card" ? cardNumber.replace(/\s/g, "") : undefined, // Remove spaces from card number
        expiryDate:
          paymentMethod === "card" ? expiryDate.replace(/\s/g, "") : undefined, // Ensure no spaces
        cvv: paymentMethod === "card" ? cvc : undefined, // CVV is mandatory for card payments
        upiId: paymentMethod === "upi" ? upiId : undefined, // UPI ID only for UPI payments
      };

      try {
        const res = await axios.post(
          "https://project-manager-backend-afgb.onrender.com/subscription/subscribe",
          { plan: currentPlan, paymentDetails },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        console.log("Response:", res);
      } catch (err) {
        console.error("Error during API call:", err);
        alert("Subscription or payment failed. Please try again.");
      }

      // Set the new plan and switch to the profile tab
      localStorage.setItem("currentPlan", currentPlan);
      setUpgradedPlan(currentPlan);

      // Close the modal if everything is successful
      handleClosepayment();
    } catch (err) {
      console.error("Subscription/payment error:", err);
      alert("Subscription or payment failed. Please try again.");
    }
  };

  const handleSubmitQuery = async () => {
    const token = localStorage.getItem("token");
    try {
      await axios.post(
        "https://project-manager-backend-afgb.onrender.com/queries",
        { message: queryMessage },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      alert("Query submitted successfully");
      setQueryMessage("");
      handleClose();
    } catch (err) {
      console.error("Error submitting query:", err);
      alert("Failed to submit query.");
    }
  };
  const handleDeleteAccount = async () => {
    const token = localStorage.getItem("token");

    if (!user.email) return alert("User email not loaded.");
    if (!window.confirm("Are you sure you want to delete your account?"))
      return;

    try {
      await axios.delete(
        "https://project-manager-backend-afgb.onrender.com/user/delete-user",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          data: { email: user.email },
        }
      );

      alert("Your account has been deleted.");

      // Clear local storage and redirect
      localStorage.clear();
      window.location.href = "/";
    } catch (error) {
      alert("Something went wrong while deleting your account.");
      console.error(error);
    }
  };

  return (
    <>
      <Navbar searchString={searchString} setSearchString={setSearchString} />
      <div className="profile-page-bg">
        <div className="container-fluid pb-2 pt-5 px-0 ">
          <div className="profile-page  p-0 ">
            <div className="topbar">
              <h2 className="p-4 text-white">
                Welcome, <span className="span">{user.name}👋</span>
              </h2>
            </div>
            <div className="d-flex justify-content-between align-items-center pt-4 pb-3 px-4">
              <div className="profile-sec">
                <div className="profile">
                  <h6>{user.name.charAt(0)}</h6>
                </div>
                <div className="profile-info">
                  <h4>
                    {user.name} {user.surname}
                  </h4>
                  <p>{user.email}</p>
                </div>
              </div>
              {/* <button className="subscription-btn">+Subscription</button> */}
            </div>
            <hr />

            <div className="container-fluid mt-4 px-4">
              <Tab.Container defaultActiveKey="home">
                <Row>
                  <Col lg={3} className="p-0  px-lg-3">
                    <Nav variant="pills" className="flex-column left-side">
                      <Nav.Item>
                        <h4 className="text-black px-3 pt-3">
                          {" "}
                          Account Overview
                        </h4>
                        <hr className="opacity-25 " />
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="home">Personal Details</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="profile">Subscription</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="longer-tab">
                          Delete account
                        </Nav.Link>
                      </Nav.Item>
                    </Nav>
                  </Col>
                  <Col className="right-side mt-3 mt-lg-0" lg={9}>
                    <Tab.Content>
                      <Tab.Pane eventKey="home">
                        <div className="update-info row">
                          <div className="col-md-6">
                            <h6>Name</h6>
                            <input
                              type="text"
                              name="name"
                              value={user.name}
                              onChange={handleChange}
                            />
                          </div>

                          <div className="col-md-6 mt-3 mt-md-0">
                            <h6>New Password</h6>
                            <input
                              type="password"
                              name="newPassword"
                              value={user.newPassword || ""}
                              onChange={handleChange}
                            />
                          </div>
                          <div className="col-md-6  mt-3">
                            <h6>Surname</h6>
                            <input
                              type="text"
                              name="surname"
                              value={user.surname}
                              onChange={handleChange}
                            />
                          </div>

                          <div className="col-md-6 mt-3 ">
                            <h6>Confirm Password</h6>
                            <input
                              type="password"
                              name="confirmPassword"
                              value={user.confirmPassword || ""}
                              onChange={handleChange}
                            />
                          </div>
                          <div className="col-md-6 mt-3 ">
                            <h6>Email</h6>
                            <input
                              type="text"
                              value={user.email}
                              readOnly
                              disabled
                              c
                            />
                          </div>

                          <div className="col-md-3 mt-0 mt-md-0">
                            <button onClick={handleUpdate}>Update</button>
                          </div>
                        </div>
                      </Tab.Pane>
                      <Tab.Pane eventKey="profile">
                        <div className="subscription-info px-3">
                          <div className="row">
                            {/* Standard Plan */}
                            <div className="col-lg-4 mb-3 mb-lg-0">
                              <div
                                className={`sub-card ${
                                  currentPlan === "Standard"
                                    ? "active-plan"
                                    : ""
                                }`}
                              >
                                <h2>Standard</h2>
                                <h1>$15</h1>

                                <p>$20 if billed monthly. 1 License Minimum</p>

                                {upgradedPlan === "Standard" ||
                                upgradedPlan === "Pro" ? (
                                  <>
                                    <p className="text-success fw-bold text-center">
                                      ✅ Current Plan: {upgradedPlan}
                                    </p>
                                    <div className="d-flex align-items-center gap-2 justify-content-center">
                                      <a
                                        href="#"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          const newPlan =
                                            upgradedPlan === "Standard"
                                              ? "Pro"
                                              : "Standard";
                                          setCurrentPlan(newPlan);
                                          handleShowpaymentModal();
                                        }}
                                      >
                                        Change to{" "}
                                        {upgradedPlan === "Standard"
                                          ? "Pro"
                                          : "Standard"}
                                      </a>
                                    </div>
                                  </>
                                ) : (
                                  <div className="d-flex align-items-center gap-2 justify-content-center">
                                    <a
                                      href="#"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        setCurrentPlan("Standard");
                                        handleShowpaymentModal();
                                      }}
                                    >
                                      Buy Now
                                    </a>
                                  </div>
                                )}

                                <hr className="my-4 opacity-25" />
                                <div className="d-flex align-items-center gap-2 plan">
                                  <TiTick />
                                  <h6>Task creation & management</h6>
                                </div>
                                <div className="d-flex align-items-center gap-2 plan">
                                  <TiTick />
                                  <h6>Due dates & priorities</h6>
                                </div>
                                <div className="d-flex align-items-center gap-2 plan">
                                  <TiTick />
                                  <h6>Basic team collaboration</h6>
                                </div>
                                <div className="d-flex align-items-center gap-2 plan">
                                  <TiTick />
                                  <h6>Email notifications</h6>
                                </div>
                                <div className="d-flex align-items-center gap-2 plan">
                                  <TiTick />
                                  <h6>Basic analytics</h6>
                                </div>
                              </div>
                            </div>

                            {/* Pro Plan */}
                            <div className="col-lg-4 mb-3 mb-lg-0">
                              <div
                                className={`sub-card pro ${
                                  upgradedPlan === "Pro" ? "active-plan" : ""
                                }`}
                              >
                                <h2>Pro</h2>
                                <h1>$25</h1>

                                <p>$30 if billed monthly. 3 License Minimum</p>

                                {upgradedPlan === "Pro" ? (
                                  <p className="text-success fw-bold text-center">
                                    ✅ Active Plan
                                  </p>
                                ) : upgradedPlan === "Standard" ? (
                                  <div className="text-center">
                                    <button
                                      className="try-btn"
                                      onClick={() => handleSubscription("Pro")}
                                    >
                                      Upgrade to Pro
                                    </button>
                                  </div>
                                ) : (
                                  <div className="d-flex align-items-center gap-2 justify-content-center">
                                    <a
                                      href="#"
                                      onClick={(e) => {
                                        e.preventDefault(); // Prevents the default anchor behavior

                                        handleShowpaymentModal();
                                        setCurrentPlan("Pro");
                                      }}
                                    >
                                      Buy Now
                                    </a>
                                  </div>
                                )}

                                <hr className="my-4 opacity-25" />
                                <h5 className="mb-2">
                                  All Standard features, plus:
                                </h5>
                                <div className="d-flex align-items-center gap-2 plan">
                                  <TiTick />
                                  <h6>Advanced task automation</h6>
                                </div>
                                <div className="d-flex align-items-center gap-2 plan">
                                  <TiTick />
                                  <h6>Calendar & Gantt views</h6>
                                </div>
                                <div className="d-flex align-items-center gap-2 plan">
                                  <TiTick />
                                  <h6>Time tracking</h6>
                                </div>
                                <div className="d-flex align-items-center gap-2 plan">
                                  <TiTick />
                                  <h6>File sharing & comments</h6>
                                </div>
                                <div className="d-flex align-items-center gap-2 plan">
                                  <TiTick />
                                  <h6>Priority support</h6>
                                </div>
                                <div className="d-flex align-items-center gap-2 plan">
                                  <TiTick />
                                  <h6>Role-based permissions</h6>
                                </div>
                              </div>
                            </div>

                            {/* Enterprise Plan */}
                            <div className="col-lg-4">
                              <div
                                className={`sub-card ${
                                  currentPlan === "Enterprise"
                                    ? "active-plan"
                                    : ""
                                }`}
                              >
                                <h2>Enterprise</h2>
                                <p>100 License Minimum</p>

                                {currentPlan === "Enterprise" ? (
                                  <p className="text-success fw-bold text-center">
                                    ✅ Active Plan
                                  </p>
                                ) : (
                                  <div className="d-flex align-items-center gap-2 justify-content-center">
                                    <button
                                      className="try-btn"
                                      onClick={handleShow}
                                    >
                                      Contact Us
                                    </button>
                                  </div>
                                )}

                                <hr className="my-4 opacity-25" />
                                <h5 className="mb-2">
                                  All Pro features, plus:
                                </h5>
                                <div className="d-flex align-items-center gap-2 plan">
                                  <TiTick />
                                  <h6>Custom workflows</h6>
                                </div>
                                <div className="d-flex align-items-center gap-2 plan">
                                  <TiTick />
                                  <h6>Dedicated success manager</h6>
                                </div>
                                <div className="d-flex align-items-center gap-2 plan">
                                  <TiTick />
                                  <h6>SSO & enterprise security</h6>
                                </div>
                                <div className="d-flex align-items-center gap-2 plan">
                                  <TiTick />
                                  <h6>Team onboarding & training</h6>
                                </div>
                                <div className="d-flex align-items-center gap-2 plan">
                                  <TiTick />
                                  <h6>99.9% uptime SLA</h6>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Tab.Pane>
                      <Tab.Pane
                        className="delete position-relative"
                        eventKey="longer-tab"
                      >
                        <div className="delete-account">
                          <img
                            src="https://img.freepik.com/premium-vector/red-cross-mark-icon-negative-choice-symbol-sign-app-button_744955-339.jpg?w=360"
                            alt=""
                          ></img>
                          <h5>Are you sure?</h5>
                          <p className="text-center">
                            Do you really want to delete your account? This
                            action cannot be undone.
                          </p>
                          <button
                            className="delete-btn"
                            onClick={handleDeleteAccount}
                          >
                            Delete
                          </button>
                        </div>
                      </Tab.Pane>
                    </Tab.Content>
                  </Col>
                </Row>
              </Tab.Container>
              <Modal show={show} onHide={handleClose} centered>
                <Modal.Header closeButton>
                  <Modal.Title className="query-txt">
                    Drop your query
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <textarea
                    className="w-100"
                    rows={5}
                    value={queryMessage || ""}
                    onChange={(e) => setQueryMessage(e.target.value)}
                    placeholder="Type your query here..."
                  />
                  <Button
                    className="submit-btn mt-2"
                    onClick={handleSubmitQuery}
                  >
                    Submit
                  </Button>
                </Modal.Body>
              </Modal>
              <Modal centered show={showpayment} onHide={handleClosepayment}>
                <Modal.Header closeButton>
                  <Modal.Title className="query-txt">Payment Information</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {/* {errorMessage && (
                    <div className="alert alert-danger">{errorMessage}</div>
                  )} */}
                  <div className="form-group">
                    <label>Payment Method</label>
                    <select
                      className="form-control mt-2 cursor-pointer"
                      value={paymentMethod}
                      onChange={(e) => setPaymentMethod(e.target.value)}
                    >
                      <option value="card">Debit/Credit Card</option>
                      <option value="upi">UPI</option>
                    </select>
                  </div>

                  {paymentMethod === "card" && (
                    <div>
                      {/* Payment form inputs using the usePaymentInputs hook */}
                      <div className="form-group mt-3">
                        <label>Card Number</label>
                        <input 
                          {...getCardNumberProps({
                            onChange: handleChangeCardNumber,
                          })}
                          value={cardNumber}
                          className="form-control mt-2"
                        />
                      </div>
                      <div className="form-group mt-3">
                        <label>Expiry Date</label>
                        <input
                          {...getExpiryDateProps({
                            onChange: handleChangeExpiryDate,
                          })}
                          value={expiryDate}
                          className="form-control mt-2"
                        />
                      </div>
                      <div className="form-group mt-3">
                        <label>CVV</label>
                        <input
                          {...getCVCProps({ onChange: handleChangeCVC })}
                          value={cvc}
                          className="form-control mt-2"
                        />
                      </div>
                      {/* Display error if there's an issue with the inputs */}
                      {meta.isTouched && meta.error && (
                        <span className="text-danger">{meta.error}</span>
                      )}
                    </div>
                  )}

                  {paymentMethod === "upi" && (
                    <div className="form-group">
                      <label>UPI ID</label>
                      <input
                        type="text"
                        className="form-control"
                        value={upiId}
                        onChange={(e) => setUpiId(e.target.value)}
                        placeholder="example@upi"
                      />
                    </div>
                    
                  )}
                    <Button className="mt-4 submit-btn" onClick={handleSubscription}>
                    Submit Payment
                  </Button>
                </Modal.Body>
             
              </Modal>
            </div>
          </div>
          {modalVisible && (
            <div
              className="modal-backdrop"
              onClick={() => setModalVisible(false)}
            >
              <div
                className="success-modal"
                onClick={(e) => e.stopPropagation()}
              >
                <img
                  height={100}
                  width={150}
                  src="https://cdni.iconscout.com/illustration/premium/thumb/lady-completed-all-of-her-business-tasks-illustration-download-in-svg-png-gif-file-formats--complete-task-list-pack-illustrations-2928993.png"
                  alt=""
                />
                <p>Profile updated successfully!</p>
                <button onClick={() => setModalVisible(false)}>Done</button>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Profile;
